(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-founder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealItems = document.querySelectorAll(".reveal-item");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          let delay = Array.from(revealItems).indexOf(entry.target) * 200; // 0.2s per item
          setTimeout(() => {
            entry.target.classList.add("active");
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  revealItems.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealItems = document.querySelectorAll(".reveal-item,.title");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          let delay = Array.from(revealItems).indexOf(entry.target) * 200;
          setTimeout(() => {
            entry.target.classList.add("active");
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  revealItems.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-label"] && !Shopify.designMode) return;
  try {
    
// Optional JS if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choose-pod"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealItems = document.querySelectorAll(".reveal-item");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  revealItems.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealItems = document.querySelectorAll(".reveal-item");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  revealItems.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  /* Add JavaScript if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta"] && !Shopify.designMode) return;
  try {
    
// Add JS here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
// Bootstrap's accordion functionality is handled via its own scripts

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
// Bootstrap's accordion functionality is handled via its own scripts

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goodbye"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealItems = document.querySelectorAll(".reveal-item");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  revealItems.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
// Scroll reveal for heading and paragraph
document.addEventListener("DOMContentLoaded", function() {
  const heading = document.querySelector('.banner-head');
  const para = document.querySelector('.banner-para');

  const reveal = () => {
    const windowHeight = window.innerHeight;
    const headingTop = heading.getBoundingClientRect().top;

    if (headingTop < windowHeight - 50) {
      heading.classList.add('reveal');
      para.classList.add('reveal');
    }
  };

  window.addEventListener('scroll', reveal);
  reveal(); // Initial check
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".hero-slide");
  const prev = document.querySelector(".hero-btn.prev");
  const next = document.querySelector(".hero-btn.next");

  if (!slides.length) return;

  let index = 0;

  function showSlide(i) {
    slides.forEach(slide => slide.classList.remove("active"));
    slides[i].classList.add("active");
  }

  if (next) {
    next.addEventListener("click", () => {
      index = (index + 1) % slides.length;
      showSlide(index);
    });
  }

  if (prev) {
    prev.addEventListener("click", () => {
      index = (index - 1 + slides.length) % slides.length;
      showSlide(index);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealItems = document.querySelectorAll(".reveal-item");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  revealItems.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laundry-madeeasy"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealItems = document.querySelectorAll(".reveal-item");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  revealItems.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-desc-accordion"] && !Shopify.designMode) return;
  try {
    
// Bootstrap's accordion functionality is handled via its own scripts

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const revealItems = document.querySelectorAll(".reveal-item");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            entry.target.classList.add("active");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    revealItems.forEach(item => observer.observe(item));
  });

  document.addEventListener("DOMContentLoaded", function () {
    const rangeInput = document.getElementById("priceRange");
    const maxPriceVal = document.getElementById("maxPriceVal");
    const minPriceVal = document.getElementById("minPriceVal");

    const productCards = document.querySelectorAll(".pod-table");

    // initial values
    minPriceVal.textContent = rangeInput.min;
    maxPriceVal.textContent = rangeInput.value;

    rangeInput.addEventListener("input", function () {
      const selectedMax = parseInt(this.value);
      maxPriceVal.textContent = selectedMax;

      productCards.forEach(card => {
        const priceEl = card.querySelector(".store-price");
        if (!priceEl) return;

        // price text la irunthu number extract pannrom
        // example: "Starts from ₹630"
        const priceText = priceEl.innerText.replace(/[^0-9]/g, "");
        const price = parseInt(priceText);

        if (price <= selectedMax) {
          card.closest(".col-md-4").style.display = "block";
        } else {
          card.closest(".col-md-4").style.display = "none";
        }
      });
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".pod-card").forEach(card => {
    const link = card.dataset.link;
    if (!link) return;

    card.addEventListener("click", function (e) {
      if (
        e.target.closest("a") ||
        e.target.closest("button") ||
        e.target.closest("form")
      ) return;

      window.location.href = link;
    });

    card.style.cursor = "pointer";
  });
});






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.testimonial-slider');
  const leftArrow = document.querySelector('.slider-arrow.left');
  const rightArrow = document.querySelector('.slider-arrow.right');
  const container = document.querySelector('.testimonial-slider-container');
  let scrollPosition = 0;

  function getCardWidth() { return slider.querySelector('.testimonial-card').offsetWidth + 20; }

  leftArrow.addEventListener('click', () => {
    scrollPosition -= getCardWidth() * 4; // scroll exactly 4 cards
    if(scrollPosition < 0) scrollPosition = 0;
    slider.style.transform = `translateX(-${scrollPosition}px)`;
  });

  rightArrow.addEventListener('click', () => {
    const maxScroll = slider.scrollWidth - container.offsetWidth;
    scrollPosition += getCardWidth() * 4;
    if(scrollPosition > maxScroll) scrollPosition = maxScroll;
    slider.style.transform = `translateX(-${scrollPosition}px)`;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  /* Fade in animation */
  const revealItems = document.querySelectorAll(".reveal-item");
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  revealItems.forEach(item => observer.observe(item));

  /* VIDEO PLAY LOGIC */
  document.querySelectorAll(".video-thumb").forEach(thumb => {
    thumb.addEventListener("click", function () {

      const videoId = this.getAttribute("data-video-id");
      const videoWrap = document.getElementById(videoId);

      if (!videoWrap) return;

      // Hide thumbnail
      this.style.display = "none";

      // Show video
      videoWrap.style.display = "block";

      // Play video
      const video = videoWrap.querySelector("video");
      if (video) {
        video.play();
      }
    });
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose-love"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealItems = document.querySelectorAll(".reveal-item,.title");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          // stagger delay based on index
          let delay = Array.from(revealItems).indexOf(entry.target) * 200; // 0.2s per item
          setTimeout(() => {
            entry.target.classList.add("active");
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  revealItems.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["works"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealItems = document.querySelectorAll(".reveal-item");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  revealItems.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();
})();
